const palette = {
    Brown100 : '#E9DACD',
    Brown200 : '#BDB1A6',
    Brown300 : '#F3F0DF',
    Brown400 : '#CFCCB8',
    Brown500 : '#636158',

    Gray100 : '#A0A0A0',
    Gray200 : '#828282',
    Gray300 : '#F9F9F9',
    Gray400 : '#F5F5F5',

    Red100 : '#F24726',
    Red200 : '#E75401',

    Pink100 : '#FFCECE',

    Blue100 : '#CEE2FF',
    Blue200 : '#68C0FF',

    Yellow100 : '#FEF445',

    Green100 : '#CEE741'


  };
  
  export default palette;